export const CREDIT_SERVICE = {
    SMILE: "smile",
    PHOTO_RECOLOUR: "photo_recolour",
} as const;

export type CreditService =
    (typeof CREDIT_SERVICE)[keyof typeof CREDIT_SERVICE];
